import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export default function usePatchDistributor() {
  const [loading, setLoading] = useState(false);

  async function execute(data: number, distributorId: string) {
    try {
      setLoading(true);
      const response = await api.patch(
        `v1/backoffice/distributors/${distributorId}`,
        {
          percantageLimit: Number(data),
        },
      );

      if (response.status === 200) {
        toast.success(ToastMessages.distributor.success.updateDistributor);
        return;
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.genericError);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.distributor.error.updateDistributor),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
